/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Due_Payments_FailedInputs */

const en_due_payments_failed = /** @type {(inputs: Due_Payments_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not open the payment. Try again.`)
};

const pl_due_payments_failed = /** @type {(inputs: Due_Payments_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się otworzyć płatności. Spróbuj ponownie.`)
};

/**
* | output |
* | --- |
* | "Could not open the payment. Try again." |
*
* @param {Due_Payments_FailedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const due_payments_failed = /** @type {((inputs?: Due_Payments_FailedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Due_Payments_FailedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_due_payments_failed(inputs)
	return en_due_payments_failed(inputs)
});